import { Stack, Typography, useTheme } from "@mui/material";
import type { FC } from "react";

type Props = {
	label: string;
	amount: string;
	bg: string;
	labelColor: string;
	amountColor: string;
};

export const InspirationStatCard: FC<Props> = ({
	label,
	amount,
	bg,
	labelColor,
	amountColor,
}) => {
	const theme = useTheme();

	return (
		<Stack
			flex={1}
			alignItems="center"
			gap={0.4}
			bgcolor={bg}
			borderRadius={theme.radii.lg}
			p={1.2}
		>
			<Typography
				variant="caption"
				color={labelColor}
				textTransform="uppercase"
				textAlign="center"
			>
				{label}
			</Typography>
			<Typography fontSize="14px" fontWeight={700} color={amountColor} tabular>
				{amount}
			</Typography>
		</Stack>
	);
};
